import { RootState } from '../../store';

export const selectSettings = (state: RootState) => state.settings;
export const selectSettingsVibration = (state: RootState) => state.settings.vibration;
export const selectSettingsSounds = (state: RootState) => state.settings.sounds;
export const selectSettingsJackpotWinNotifications = (state: RootState) =>
  state.settings.jackpotWinNotifications;
export const selectSettingsAnimations = (state: RootState) => state.settings.animations;
